import type { Engine, ISourceOptions } from "@tsparticles/engine";

import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { useMemo } from "react";

const particlesInit = async (engine: Engine): Promise<void> => {
  await loadSlim(engine);
};

type LoginParticlesBackgroundProps = {
  className?: string;
  options?: ISourceOptions | null;
};

const LoginParticlesBackground = ({ className, options }: LoginParticlesBackgroundProps) => {
  const particleOptions = useMemo(() => options, [options]);

  if (!particleOptions) {
    return null;
  }

  return (
    <div aria-hidden className={className}>
      <ParticlesProvider init={particlesInit}>
        <Particles className="h-full w-full" id="login-particles" options={particleOptions} />
      </ParticlesProvider>
    </div>
  );
};

export default LoginParticlesBackground;
